/* eslint-disable */



import React, { Component } from 'react'

import { View, Text, TouchableOpacity, Image } from 'react-native'
import styles from './Styles/KargoeTagRowStyle'
import { ButtonGroup, ListItem } from "react-native-elements"

import SectionHeader from './SectionHeader';
import Spacer from './Spacer';
import ImageComponent from './ImageComponent'
import TextComponent from './TextComponent'
import { Fonts, Images } from '../Themes'
import { SvgEndorse } from './SvgComponent'
import I18n from "i18n-js"

export default class KargoeTagRow extends Component {

  checkImage = (data) => {
    if (data.ImageUrls && data.ImageUrls.length > 0) {
      return <TouchableOpacity onPress={() => this.props.onLeftPress(data)}>
        <Image source={{ uri: data.ImageUrls[0] }} style={styles.image} resizeMode="cover" />
      </TouchableOpacity>
    } else {
      return <View style={{ alignSelf: 'center' }}>
        <TouchableOpacity onPress={() => this.props.onLeftPress(data)}>
          <SvgEndorse size={30} /></TouchableOpacity>
      </View>
    }

  }
  render() {

    const { mainTitle, title
          , onPressRightIcon = ( ( ) => { } )
          , subTitle
          , data, onLeftPress
          , isSpacer
          } = this.props


    return (
      <View style={[styles.container, isSpacer && styles.bottomBorder]}>
        <TextComponent text={mainTitle} containerStyle={styles.mainTitleContainer} style={styles.mainTitle} />
        <View style={styles.content}>
          <View style={styles.left}>
            <TouchableOpacity
              onPress={() => onLeftPress(data)}
              style={styles.endorse} >
              {this.checkImage(data)}
            </TouchableOpacity>
            <View style={styles.leftText}>
              <TouchableOpacity
                onPress={() => onLeftPress(data)}
              >
                <TextComponent containerStyle ={{marginBottom: 5}} style={styles.title} text={title} />
                <TextComponent numberOfLines = {0} style={styles.subTitle} text={subTitle} />
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.right}>
            <SectionHeader
              style={[styles.buttonText, { color: Fonts.style.color.baseColor }]}
              containerStyle={[styles.button, { backgroundColor: '#FFFFFF' }]}
              text={I18n.t('explora.endorseIt')}
              onPress={( ) => onPressRightIcon(data)}
            />
          </View>
        </View>

      </View>

    )
  }
}
